export const INFO = 'info';
export const SUCCESS = 'success';
export const WARNING = 'warning';
export const DANGER = 'danger';
export const NEUTRAL = 'neutral';
